(ns teamoesterreich.view-state
  (:require
    [teamoesterreich.ajax :as ajax]
    [teamoesterreich.web-path :as web-path]
    [cljs.reader :as reader]
    [reagent.core :as reagent]))



(defonce empty-store {:site              :landing
                      :actual-user       {:tom-id 0
                                          :name {:first "Max" :last "Mustermann"}}

                      :toe-map           {:searchLatitude   nil
                                          :searchLongitude  nil
                                          :activeUserPopup  nil
                                          :map-search-state {:sort :user-lastName :reverse true :search "" :autoCompleteObj nil :invalidate true :invalidateMarker true :highLightToe 0}
                                          }
                      :organisations     nil
                      :toe-elements      []
                      :user-detail       {}
                      :selected-elements {:lists        []
                                          :selected     []
                                          :lists-loaded false
                                          :loaded       false
                                          :name         "actual"
                                          }

                      :toe-list          {:search          ""
                                          :loaded          false
                                          :filter          {}
                                          :searchAddFields {:tomId true :name true :email true :phone true}
                                          }
                      :lr-statistic      {:invalidated true
                                          :loaded      false}
                      :webHelpText-list  {:opened nil}


                      :load-state        :nothing
                      :show-menu         true
                      :ws-connected      false

                      :translations      {}
                      :texts             {}
                      :event-conditions  {}

                      })


(defonce auth-state (reagent/atom nil))
(defonce app-state (reagent/atom empty-store))
(defonce ws-state (reagent/atom {}))

(def TEXT_MAP {})
(def TRANSLATION_MAP {})

(def MAP_CENTER (js/google.maps.LatLng. 49.21025 11.38099))
(def MAP_ZOOM 7.8)

(defn reset []
  (reset! app-state empty-store)
  )

(defn !noStr [str]
  (and str (not= str "")))

(defn make-token [entity & [entityId sub1 sub2]]
  (str "" (name entity) (when entityId (str "$" entityId (when (!noStr sub1) (str "$" sub1 (when (!noStr sub2) (str "$" sub2))))))))

(defn get-path-map []
  (zipmap [:entity :entityId :sub1 :sub2] (.split (web-path/get-token) "$")))



(defn update-path! []
  (let [{:keys [entity entityId sub1 sub2]} (:path @app-state)]
    (web-path/nav! (make-token entity entityId sub1 sub2) )))

(defn set-path! [entity & [entityId sub1 sub2]]
  (swap! app-state assoc :path { :entity entity :entityId entityId :sub1 sub1 :sub2 sub2})
  (update-path!)
  )


(defn get-texts []
  (ajax/get>> (str "/custom/texts.edn")
              (fn [r-list status]
                (let [t (reader/read-string r-list)]
                  (def TEXT_MAP t)
                  (def MAP_CENTER (js/google.maps.LatLng. (get-in t [:core :map-center-lat]) (get-in t [:core :map-center-lng])))
                  (def MAP_ZOOM (get-in t [:core :map-zoom]))
                  (web-path/set-title (get-in t [:core :title]))
                  (set! (. js/document -title) web-path/title)
                  ))))

(defn get-translations []
  (ajax/get>> (str "/custom/translations.edn")
              (fn [r-list status]
                (let [t (reader/read-string r-list)]
                  (def TRANSLATION_MAP t)

                  ))))

;(:texts @app-state)

;(reagent/cursor  app-state [:toe-map])
;(get (deref app-state) :toe-map)
